import {createReducer} from "redux-act";
import {
	addPrediction,
	checkSavedPredictions,
	clearEditPredictionData,
	clearPredictions,
	editPrediction,
	fetchPredictionSimulateLiteSuccess,
	fetchPredictionSimulateSuccess,
	fetchPredictionsSuccess,
	removeSelectedSquad,
	savePredictionsInStorage,
	savePredictionsSuccess,
	setActivePot,
	setFullLockout,
	setPrediction1ForEdit,
	setPrediction2ForEdit,
	setSelectedSquad,
} from "apps/DRAW_PREDICTOR/modules/actions";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {concat} from "lodash";
import {positionA1} from "apps/DRAW_PREDICTOR/modules/constants";
import {getUserUuid, trackAdobeAnalytics} from "modules";
import PersistStorage from "modules/utils/PersistStorage";

export interface IPrediction {
	squadId: number;
	namegroup: Groups | string;
	position: number;
}

export interface IPicksReducer {
	predictions: IPrediction[];
	activePot: number;
	selectedSquad: number | null;
	predictionId1ForEdit: number | null;
	predictionId2ForEdit: number | null;
	isLocked: boolean;
	isChangePredictor: boolean;
}

const initial: IPicksReducer = {
	predictions: [positionA1],
	activePot: 1,
	selectedSquad: null,
	predictionId1ForEdit: null,
	predictionId2ForEdit: null,
	isLocked: false,
	isChangePredictor: false,
};

const savePredictionToState = (state: IPicksReducer, payload: IPrediction[]) => ({
	...state,
	predictions: payload.length !== 0 ? payload : [positionA1],
	isChangePredictor: false,
});

const user = getUserUuid();

export const predictions = createReducer<IPicksReducer>({}, initial)
	.on(clearPredictions, () => initial)
	.on(addPrediction, (state, payload) => ({
		...state,
		predictions: concat(state.predictions, payload),
		selectedSquad: null,
		isChangePredictor: true,
	}))
	.on(setActivePot, (state, payload) => ({
		...state,
		activePot: payload,
	}))
	.on(setSelectedSquad, (state, payload) => ({
		...state,
		selectedSquad: payload,
	}))
	.on(removeSelectedSquad, (state) => ({
		...state,
		selectedSquad: null,
	}))
	.on(fetchPredictionSimulateSuccess, savePredictionToState)
	.on(fetchPredictionSimulateLiteSuccess, savePredictionToState)
	.on(fetchPredictionsSuccess, savePredictionToState)
	.on(savePredictionsSuccess, savePredictionToState)
	.on(setFullLockout, (state) => ({
		...state,
		isLocked: true,
	}))
	.on(setPrediction1ForEdit, (state, payload) => ({
		...state,
		predictionId1ForEdit: payload,
	}))
	.on(setPrediction2ForEdit, (state, payload) => ({
		...state,
		predictionId2ForEdit: payload,
	}))
	.on(editPrediction, (state, payload) => {
		let teamA = "";
		let teamB = "";
		const updatedPredictions = state.predictions.map((prediction: IPrediction) => {
			if (state.predictionId2ForEdit === prediction.squadId && state.predictionId1ForEdit) {
				teamB = payload[prediction.squadId].name;
				return {
					squadId: state.predictionId1ForEdit,
					namegroup: prediction.namegroup,
					position: prediction.position,
				};
			}

			if (state.predictionId1ForEdit === prediction.squadId && state.predictionId2ForEdit) {
				teamA = payload[prediction.squadId].name;
				return {
					squadId: state.predictionId2ForEdit,
					namegroup: prediction.namegroup,
					position: prediction.position,
				};
			}

			return prediction;
		});

		trackAdobeAnalytics({
			section: "",
			eventName: "drawTeamSwitch",
			optional: {
				teamA,
				teamB,
			},
		});
		return {
			...state,
			predictionId1ForEdit: null,
			predictionId2ForEdit: null,
			predictions: updatedPredictions,
			isChangePredictor: true,
		};
	})
	.on(clearEditPredictionData, (state) => ({
		...state,
		predictionId1ForEdit: null,
		predictionId2ForEdit: null,
	}))
	.on(savePredictionsInStorage, (state) => {
		PersistStorage.SET(`lite-draw-${user}`, state.predictions);

		return {
			...state,
		};
	})
	.on(checkSavedPredictions, (state) => {
		const saved = JSON.parse(PersistStorage.GET(`lite-draw-${user}`) || "null") as
			| IPrediction[]
			| null;

		return {
			...state,
			predictions: saved || [positionA1],
		};
	});
